import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';
import getInventoryByVmIdRes from './getInventoryByVmId.json';
import getAllModelRes from './getAllModel.json';
import getConfigByModelRes from './getConfigByModel.json';
import addRes from './add.json';
import getByIdRes from './getById.json';
import deleteByIdRes from './deleteById.json';
import getPlanogramByVmIdRes from './getPlanogramByVmId.json';
import updateColumnRes from './updateColumn.json';
import findAllRes from './findAll.json';
import getAllCategoryRes from './getAllCategory.json';
import getAllTrayRes from './getAllTray.json';
import getDexReadingRes from './getDexReading.json';

const getInventoryByVmId = (vmId: string | number | undefined) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}vm-inventory?vmId=${vmId}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getInventoryByVmIdRes>(url, config);
};

const getVMSales = ({ start, end, vmId }: { start?: string, end?: string, vmId: string | number }) => {
  /* format date 04/01/2021 */
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}vm-sales-summary?vmId=${vmId}&start=${start}&end=${end}`;
  return axios.get(url, {
    responseType: 'json',
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  });
};

const getPDFByVmId = ({ start, end, vmId }: { start?: string, end?: string, vmId: string | number }) => {
  /* format date 04/01/2021 */
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}vm-sales-pdf?vmId=${vmId}&start=${start}&end=${end}`;
  return axios.get(url, {
    responseType: 'blob',
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  });
};

const getAllModel = (page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-vm-models?page=${page ?? 0}&size=${size ?? 1000}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllModelRes>(url, config);
};

const getDexReading = (id: string, page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}dexreading?vmId=${id}&page=${page ?? 0}&size=${size ?? 10}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getDexReadingRes>(url, config);
};

const getConfigByModel = (modelName: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}find-vm-by-model?model=${modelName}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getConfigByModelRes>(url, config);
};

export interface addVendingMachineProps {
  vmId?: string,
  deviceId: string,
  clientId: string,
  location: string,
  modelConfigId: string,
  extModelConfigId?: number
}

const add = (data: addVendingMachineProps) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-vm-v2`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post<typeof addRes>(url, data, config);
};

const getById = (id: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-vending-machine?vmId=${id}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getByIdRes>(url, config);
};

const deleteById = (vmId: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}remove-vm`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  const data = {
    vmId,
  };
  return axios.post<typeof deleteByIdRes>(url, data, config);
};

const getPlanogramByVmId = (id: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}vm-planogram?vmId=${id}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getPlanogramByVmIdRes>(url, config);
};

const getPlanogramBModelmId = (id: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}all-active-clients-by-model?modelId=${id}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getCoffeeOrder = (id: string, scheduleDate: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}order-coffee?vmId=${id}&scheduleDate=${scheduleDate}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getCoffeeOrderPDF = (id: string | number, scheduleDate: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}coffee-sales-pdf?vmId=${id}&scheduleDate=${scheduleDate}`;
  return axios.get(url, {
    responseType: 'blob',
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  });
};

export interface updateVMColumnData {
  'columnId': string,
  'price': string,
  'productId': string
}

export interface updateVMBatchColumnData {
  'currentProduct': string | number,
  'price': string | number,
  'productId': string | number
}

const updateColumn = (data: updateVMColumnData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}vm-inventory-update`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post<typeof updateColumnRes>(url, data, config);
};

const updateBatchColumn = (data: updateVMBatchColumnData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}vm-batch-update`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post<typeof updateColumnRes>(url, data, config);
};

const updateCopyPlanogram = (data: {
  fromVM: string | number,
  toVM: string | number,
}) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}copy-planogram`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const findAll = (query: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}search-vm?q=${query}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof findAllRes>(url, config);
};

const getAllCategory = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-all-categories`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllCategoryRes>(url, config);
};

const getAllTray = (page?: string, size?: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-trays?page=${page ?? 0}&size=${size ?? 20}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllTrayRes>(url, config);
};

const findAllTray = (selection?: string, start?: string, numbering?: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}find-tray?${!!selection && selection !== '' ? `&selection=${selection}` : ''}${!!start && start !== '' ? `&start=${start}` : ''}${!!numbering && numbering !== '' ? `&numbering=${numbering}` : ''}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllTrayRes>(url, config);
};

const deleteModel = (id: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}delete-vm-model`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { id }, config);
};

const deleteModelConfiguration = (id: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}delete-model-config`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { id }, config);
};

interface NewModelData {
  'model': string;
  'type': number;
  'trays': number[];
  'configName': string;
}

const addNewModel = (data: NewModelData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-vm-model`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface ConfigToModelData {
  'id': number;
  'trays': number[];
  'configName': string;
}

const addConfigToModel = (data: ConfigToModelData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-tray-vm-model`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

const vendingMachines = {
  getInventoryByVmId,
  getAllModel,
  add,
  getById,
  getPlanogramBModelmId,
  deleteById,
  getConfigByModel,
  updateCopyPlanogram,
  getPlanogramByVmId,
  updateColumn,
  updateBatchColumn,
  findAll,
  getAllCategory,
  deleteModelConfiguration,
  deleteModel,
  getAllTray,
  findAllTray,
  addNewModel,
  addConfigToModel,
  getPDFByVmId,
  getCoffeeOrder,
  getCoffeeOrderPDF,
  getVMSales,
  getDexReading,
};

export default vendingMachines;
